import themeFunctions from './components/theme-functions.js'
import navdefault from './components/nav-default.js'
import menumain from './components/menu-main.js'

export default {
    themeFunctions,
    navdefault,
    menumain
}
